import React, { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { opsMoney, opsPercent } from './OpsProfitabilityModel';

export default function OpsResaleComparison({ comparison, label, close }) {
  const dialog = useRef(null);
  const previousFocus = useRef(document.activeElement);
  const titleId = useId();
  const currency = comparison.moneda || 'MXN';
  const known = comparison.costo_anterior != null && comparison.costo_actual != null;
  const deviation = known ? comparison.desviacion : null;
  const variation = known ? comparison.porcentaje_variacion : null;
  const observations = (comparison.serie || []).slice(0, 2).map((entry, index) => ({ ...entry,
    label: index === 0 ? 'Cierre anterior' : 'Corte actual' }));
  useEffect(() => {
    const element = dialog.current;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    element.showModal();
    return () => { element.close(); document.body.style.overflow = overflow; previousFocus.current?.focus(); };
  }, []);
  return <dialog ref={dialog} className="opr-dialog opr-resale-comparison" aria-labelledby={titleId}
    onCancel={event => { event.preventDefault(); close(); }}>
    <header><div><h2 id={titleId}>Comparativa Resale Cloud</h2><p>{label}</p></div>
      <button type="button" autoFocus className="opr-icon" aria-label="Cerrar comparativa Resale" title="Cerrar" onClick={close}><X size={19} /></button></header>
    <dl className="opr-resale-kpis">
      <div><dt>Costo anterior · {comparison.mes_anterior}</dt><dd>{opsMoney(comparison.costo_anterior, currency)}</dd></div>
      <div><dt>Costo actual estimado · No facturado</dt><dd>{opsMoney(comparison.costo_actual, currency)}</dd></div>
      <div><dt>Incremento absoluto</dt><dd className={deviation > 0 ? 'opr-bad' : deviation == null ? 'opr-pending' : 'opr-ok'}>{opsMoney(deviation, currency)}</dd></div>
      <div><dt>Variación porcentual</dt><dd className={variation > 0 ? 'opr-bad' : variation == null ? 'opr-pending' : 'opr-ok'}>{opsPercent(variation)}</dd></div>
    </dl>
    <figure className="opr-resale-figure" aria-label="Comparación de costo anterior y actual">
      <div className="opr-resale-chart" aria-hidden="true"><ResponsiveContainer width="100%" height="100%">
        <AreaChart data={observations} margin={{ top: 16, right: 20, left: 12, bottom: 8 }}>
          <CartesianGrid stroke="var(--opr-grid)" vertical={false} />
          <XAxis dataKey="label" tick={{ fill: 'var(--opr-muted)', fontSize: 11 }} interval={0} />
          <YAxis width={65} tick={{ fill: 'var(--opr-muted)', fontSize: 11 }} tickFormatter={value => new Intl.NumberFormat('es-MX', { notation: 'compact' }).format(value)} />
          <Tooltip content={({ active, payload }) => active && payload?.length ? <div className="opr-tooltip"><strong>{payload[0].payload.label} · {payload[0].payload.fecha}</strong>{opsMoney(payload[0].value, currency)}</div> : null} />
          <Area type="linear" dataKey="costo" stroke="var(--opr-operative)" fill="var(--opr-operative)" fillOpacity={0.15} dot={{ r: 5 }} connectNulls={false} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer></div>
      <dl className="opr-resale-observations">{observations.map(entry => <div key={`${entry.label}:${entry.fecha}`}><dt>{entry.label} · {entry.fecha}</dt><dd>{opsMoney(entry.costo, currency)}</dd></div>)}</dl>
    </figure>
  </dialog>;
}